<template>
  <div class="backNav">
    <div class="inner">
      <img src="../../assets/images/logo.png" @click="goHome">
      <div class="backBtn" @click="goHome">返回首页</div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
    export default {
      methods:{
        goHome(){
          this.$router.push('/');
        }
      }
    }
</script>
<style scoped>
  .backNav{
    height: 70px;
    background: rgb(39,100,194);
    padding-top: 5px;
  }
  .backBtn{
    width: 90px;
    height: 30px;
    float: right;
    border: 1px solid #ffffff;
    color: #ffffff;
    border-radius: 5px;
    font-size: 14px;
    text-align: center;
    line-height: 30px;
    margin-top: 15px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/backHome.vue